import { Snackbar, styled } from '@mui/material';
import { useEffect, useState } from 'react';

import { MessageBus, useMessageBusData } from '@app-velocity/message-bus';
import { Alert } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

const messageBus = new MessageBus('system');

const AlertContainer = styled('div')({
  width: '100%',
});

const SnackbarBackdrop = styled('div')<{ visible: boolean }>(({ visible }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: 90,
  zIndex: 999,
  opacity: visible ? 1 : 0,
  transition: '.25s all',
  background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 100%);',
}));

export const SnackbarContainer = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [containerVisible, setContainerVisible] = useState(false);
  const data = useMessageBusData('notification', messageBus);

  useEffect(() => {
    if (!data) {
      return;
    }

    setContainerVisible(true);
    setOpen(true);
  }, [data]);

  const onClose = () => {
    setOpen(false);
    setTimeout(() => {
      setContainerVisible(false);
    }, 250);
  };

  if (!data || !containerVisible) return;

  return (
    <>
      <SnackbarBackdrop visible={open} />
      <Snackbar open={open} autoHideDuration={5000} onClose={onClose}>
        {/* Div is necessary to properly handle element ref and avoid error */}
        <AlertContainer>
          <Alert severity="info" onClose={onClose} title={t(data.title)}>
            {data?.message}
          </Alert>
        </AlertContainer>
      </Snackbar>
    </>
  );
};
